import { FieldErrorProps } from '@rjsf/utils';
import { InputErrorMessage } from 'node_modules/@commenda/kakashi';

export const FieldErrorTemplate = (props: FieldErrorProps) => {
  const { errors } = props;
  if (!errors) return null;
  return (
    <div className="flex flex-col gap-1 mt-2">
      {errors.map((error: string, i: number) => {
        return <InputErrorMessage key={i} message={error} />;
      })}
    </div>
  );
};
